// extracted by mini-css-extract-plugin
export var alignLeft = "y_rd d_fp d_bG d_dv";
export var alignCenter = "y_bP d_fq d_bD d_dw";
export var alignRight = "y_rf d_fr d_bH d_dx";
export var comparisonComponentContentEqual = "y_h9 d_h9 d_b1 d_w d_bz d_bF d_bJ d_w";
export var comparisonComponentEqual = "y_jc d_jc d_w d_y d_cX";
export var positioner = "y_sv";
export var wrapper = "y_sw d_c8";